import { isAlive } from "mobx-state-tree";
import { ChartApiResponse, ChartApiResponseData, ChartApiResponseMeta } from "../../hooks/useChartData";
import { chartUrl } from "../../jefdaqLegacyApi/chart";
import { fetchRatedAPI } from "../../jefdaqLegacyApi/rated";
import { ISelectedSensor } from "../../models/SelectedSensor";
import { SensorDisplayPrecip } from "../../models/SensorDisplay";

interface LegacyChartApiResponse {
  dur: number;
  interval: number;
  source: {
    data: number[][];
    max: number;
    min: number;
    unit?: string;
    xunits?: string;
    yunits?: string;
  };
}

const fetchChart = async (selected: ISelectedSensor): Promise<ChartApiResponse | undefined> => {
  let fetchRated = undefined
  if (selected.display.measure === "discharge") {
    fetchRated = await fetchRatedAPI()
  }

  const url = chartUrl(fetchRated, selected);
  if (url === undefined) {
    throw new Error("Could not create URL for chart API");
  }

  const headers = { "Content-Type": "application/json" };
  const legacyFetch = await fetch(url.toString(), { headers });

  if (!legacyFetch.ok) {
    throw new Error("Bad response from chart API");
  }

  const legacyResponse: LegacyChartApiResponse = await legacyFetch.json()
  if (!isAlive(selected)) {
    return undefined;
  }


  const { display } = selected
  const { source } = legacyResponse;
  const measure = SensorDisplayPrecip.is(display) ? "precip" : display.measure;
  const unit = source.unit || source.yunits || ""

  const meta: ChartApiResponseMeta = { units: { [measure]: unit } }
  // @ts-ignore
  const data: ChartApiResponseData[] = legacyResponse.source.data.map(([ts, value]) => ({
    ts: new Date(ts), [measure]: value
  }))

  return { meta, data };

};

export default fetchChart;
